

















































import { computed, defineComponent, onMounted, PropType, ref, watch } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useClampingView from "@/hooks/useClampingView";
import { getElement } from "@/lib/elementHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import AttachmentsInfo from "@/components/AttachmentsInfo";
import BaseButton from "@/components/BaseButton";
import ContentFeedBaseView from "@/components/ContentFeedItem/components/ContentFeedBaseView";
import ContentFeedUnlockFeed from "@/components/ContentFeedItem/components/ContentFeedUnlockFeed";
import WysiwygViewer from "@/components/WysiwygViewer";

export default defineComponent({
  name: "TextView",

  components: {
    BaseButton,
    ContentFeedUnlockFeed,
    AttachmentsInfo,
    WysiwygViewer,
    ContentFeedBaseView,
  },
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    showFollowButton: { type: Boolean, default: false },
    showReportItem: { type: Boolean, default: true },
    showComment: { type: Boolean, default: true },
    showReview: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    showContentSales: { type: Boolean, default: true },
    pinnedPostId: { type: String as PropType<string | null>, default: null },
    enablePinPost: { type: Boolean, default: false },
    isFollowedUser: { type: Boolean },
    previewMode: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { authUser } = useAuthUser();
    const contentFeedItem = ref();
    const {
      clampingComponent: wysiwyg,
      expanded,
      styleHeight,
      clampOnMount,
      showHeightToggle,
      toggleExpanded,
    } = useClampingView();

    const isAuthor = computed(() => !!authUser.value && props.contentFeed?.userId === authUser.value.id);

    const isFreePost = computed(() => {
      if (!props.contentFeed) return false;
      return props.contentFeed.pricePackageId === "0" && props.contentFeed.subscriptionLevelId === "0";
    });

    const canAccessPost = computed(() => isAuthor.value || isFreePost.value || props.contentFeed.purchased);

    const contentFeedLocked = computed(() => !canAccessPost.value && !props.contentFeed.user.disabled);

    const coverFile = computed(() => props.contentFeed.files.find(f => f.publicAccess));

    const coverStyle = computed(() => {
      if (coverFile.value) {
        const background = MediaFilesController.getImageThumbnail(coverFile.value.urlPart, "1080p");
        return { "--backgroundImage": `url(${background})` };
      }
      return {};
    });

    watch(expanded, value => {
      if (!value) {
        getElement<HTMLElement>(contentFeedItem.value).scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      }
    });

    onMounted(() => {
      if (canAccessPost.value) {
        clampOnMount();
      }

      emit("mounted", getElement(contentFeedItem.value));
    });

    return {
      expanded,
      contentFeedItem,
      wysiwyg,
      showHeightToggle,
      contentFeedLocked,
      isAuthor,
      coverFile,
      coverStyle,
      styleHeight,
      canAccessPost,
      toggleExpanded,
    };
  },
});
